import { useEffect, useState } from "react"
import styled from "styled-components"
import AdminService from "../../../services/admin.service"

interface Lead {
    id: number; session_id: string; nombre_apellido?: string; correo?: string;
    whatsapp?: string; estado_lead?: string; fecha_creacion?: string;
    fecha_compra?: string; total_clp?: number | string; comprobante?: string;
}

export default function Leads() {
    const [leads, setLeads] = useState<Lead[]>([])
    const [loading, setLoading] = useState(false)

    const load = async () => {
        setLoading(true)
        try { const { data } = await AdminService.getBotLeads(); setLeads(Array.isArray(data) ? data : []) }
        catch { setLeads([]) } finally { setLoading(false) }
    }
    useEffect(() => { load() }, [])

    const fecha = (d?: string) => d ? new Date(d).toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" }) : "—"
    const clp = (n?: number | string) => n ? "$" + Number(n).toLocaleString("es-CL") : "—"

    const ESTADOS = ["nuevo", "contactado", "cotizado", "ganado", "perdido"]
    const updateEstado = async (id: number, estado: string) => {
        setLeads(prev => prev.map(l => l.id === id
            ? { ...l, estado_lead: estado, fecha_compra: estado === "ganado" ? (l.fecha_compra || new Date().toISOString()) : undefined }
            : l))
        try { await AdminService.updateBotLead(id, estado) } catch { load() }
    }
    const archivar = async (id: number) => {
        setLeads(prev => prev.filter(l => l.id !== id))
        try { await AdminService.archivarBotLead(id) } catch { load() }
    }

    const ganados = leads.filter(l => l.estado_lead === "ganado").length
    const conversion = leads.length ? Math.round(ganados / leads.length * 100) : 0

    return (
        <Wrap>
            <Head>
                <span>{leads.length} leads · {ganados} ganados · {conversion}% conversión</span>
                <button onClick={load}>&#8635; Refrescar</button>
            </Head>
            {loading && <Empty>Cargando…</Empty>}
            {!loading && leads.length === 0 && <Empty>Aún no hay leads capturados</Empty>}
            {!loading && leads.length > 0 && (
                <Table>
                    <thead><tr><th>Nombre</th><th>Correo</th><th>WhatsApp</th><th>Estado</th><th>Total</th><th>Creado</th><th>Compra</th><th>Comprobante</th><th></th></tr></thead>
                    <tbody>
                        {leads.map(l => (
                            <tr key={l.id}>
                                <td>{l.nombre_apellido || "—"}</td>
                                <td>{l.correo || "—"}</td>
                                <td>{l.whatsapp || "—"}</td>
                                <td>
                                    <select className={`estado ${l.estado_lead}`} value={l.estado_lead || "nuevo"}
                                        onChange={e => updateEstado(l.id, e.target.value)}>
                                        {ESTADOS.map(s => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                </td>
                                <td>{clp(l.total_clp)}</td>
                                <td>{fecha(l.fecha_creacion)}</td>
                                <td>{fecha(l.fecha_compra)}</td>
                                <td>{l.comprobante
                                    ? <a className="comp" href={`${process.env.REACT_APP_API_URL}/files/${l.comprobante}`} target="_blank" rel="noreferrer">Ver</a>
                                    : "—"}</td>
                                <td><button className="arch" title="Archivar lead" onClick={() => archivar(l.id)}>Archivar</button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Wrap>
    )
}

const Wrap = styled.div`height:100%;overflow-y:auto;`
const Head = styled.div`
display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;font-size:13px;color:#8B7355;
button{border:none;background:#f2ebe0;border-radius:8px;padding:6px 12px;cursor:pointer;font-size:13px;}
`
const Table = styled.table`
width:100%;border-collapse:collapse;font-size:13px;
th,td{text-align:left;padding:9px 10px;border-bottom:1px solid #eee5d8;}
th{color:#8B7355;font-weight:600;font-size:12px;}
td{color:#2D2318;}
.comp{color:#2f4c8b;text-decoration:underline;font-weight:600;}
.arch{border:none;background:#f2ebe0;color:#8B7355;border-radius:8px;padding:4px 10px;cursor:pointer;font-size:12px;}
.arch:hover{background:#e8ddc9;}
.estado{padding:3px 8px;border-radius:10px;background:#f2ebe0;color:#8B7355;font-size:11px;border:1px solid #e3d8c5;cursor:pointer;font-weight:600;}
.estado.ganado{background:#e2efda;color:#3c6b2f;}
.estado.perdido{background:#f4d5d0;color:#9e2a1e;}
.estado.cotizado{background:#e0e8f4;color:#2f4c8b;}
.estado.contactado{background:#f4eeda;color:#8b7a2f;}
`
const Empty = styled.div`color:#A09070;font-size:13px;text-align:center;padding:36px;`
